"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var agreements_1 = require("./agreements");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.AgreementsEventNames.Agreements] = agreements_1.agreements,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
